var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"sc-page-sheet"},[_c('TariffTable',{attrs:{"alltypes":""},on:{"onClose":function($event){return _vm.$router.push('/')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }